import { getMessage } from '../commons'

export default (messages, index) => {
  if (index === null || index === undefined) {
    if (!messages) { 
      return null
    } 
    return [].concat(messages)
  }
  if (!messages) { // 메시지 null (메시지 초기 생성)
    return [getMessage()]
  }
  if (messages && (index || index===0)) { // 인덱스를 지정해 준 경우
    messages.splice(index, 0, getMessage())
    const new_currentEditMessage = [...messages] // Issue with React rendering
    
    return new_currentEditMessage
  }
  window.alert("메시지를 추가할 수 없습니다.")
  console.error("메시지가 있는데 index는 지정이 되지 않았음 (오류)")
  console.error('index :', index);

  return [].concat(messages)
}